import { FormControl } from '@angular/forms';

// å¯ç ä¸­å¿é¡»åå«å­æ¯ãæ°å­ãç¹æ®å­ç¬¦ï¼è³å°8ä¸ªå­ç¬¦ï¼æå¤30ä¸ªå­ç¬¦ã
export const passwordComplexity = (control: FormControl): { [s: string]: boolean } => {
    const regex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}');
    if (!control.value) {
        return {error: true, required: true};
    } else if (!regex.test(control.value)) {
        return {complexity: true, error: true};
    }
    return {};
}
